import { VisionApplication } from '../application';
import { UserDTO, UserService, UserSettings } from '../service/user.service';
import { VisionWindowManager } from './manager';
import { VisionWindow } from './window';

export class VisionUserWindow extends VisionWindow {
    private layout!: dhtmlXLayoutObject;
    private infoLayout!: dhtmlXLayoutObject;
    private loginForm!: dhtmlXForm;
    private tabForm!: dhtmlXForm;
    private settingsForm!: dhtmlXForm;
    private users!: dhtmlXGridObject;
    private toolbar!: dhtmlXToolbarObject;
    private service!: UserService;
    public sideBar!: dhtmlXSideBar;
    private zoomSlider!: dhtmlXSlider;

    private rolesGrid!: dhtmlXGridObject;

    private cache!: Map<string, UserDTO>;
    private tabs = ['avl', 'fleet', 'pm', 'spot_rocking', 'rock_pits', 'rocking', 'grading', 'mowing', 'plowing', 'spreading', 'camera'];

    constructor(manager: VisionWindowManager) {
        super(manager, {
            id: 'edit_user_window',
            title: 'Users',
            x: 10,
            y: 10,
            width: 1000,
            height: 600,
        });
        this.window.setText('User');
        this.modal = true;
        this.cache = new Map<string, UserDTO>();
        this.service = VisionApplication.getInstance().userService;

        this.buildUI();
        this.buildHandlers();
    }

    private buildUI() {
        this.layout = this.window.attachLayout('2U');
        this.layout.cells('a').hideArrow();
        this.layout.cells('a').setWidth(200);
        this.layout.cells('b').hideArrow();

        this.layout.cells('a').setText('Users');
        this.layout.cells('b').setText('Details');

        this.users = this.layout.cells('a').attachGrid();
        this.users.setHeader('Username', '', []);
        this.users.setColSorting('str');
        this.users.init();

        this.toolbar = this.layout.cells('b').attachToolbar();
        this.toolbar.addButton('new', 0, 'New', 'icons/sign.png', '');
        this.toolbar.addButton('save', 1, 'Save', 'css/imgs/save.gif', '');
        this.toolbar.addSeparator('sep1', 2);
        this.toolbar.addButton('delete', 3, 'Delete', 'icons/clear.png', '');

        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();

        this.sideBar = this.layout.cells('b').attachSidebar({ width: 120 });
        this.sideBar.addItem({ id: 'login_info', text: 'Information', icon: 'icons/information.png' });
        this.sideBar.addItem({ id: 'settings', text: 'Settings', icon: 'icons/information.png' });
        this.sideBar.addItem({ id: 'tabs', text: 'Tabs', icon: 'icons/information.png' });

        const loginFormData = [
            {
                type: 'fieldset',
                name: 'login_info',
                label: 'Login Info',
                width: 300,
                offsetLeft: '25',
                list: [
                    { name: 'id', type: 'input', label: 'ID', value: '', inputWidth: '250', offsetLeft: '5', offsetTop: '5', disabled: true },
                    { name: 'username', type: 'input', label: 'Username', value: '', inputWidth: '250', offsetLeft: '5', required: false },
                    { name: 'password', type: 'password', label: 'Password', value: '', inputWidth: '150', offsetLeft: '5', required: false },
                    {
                        name: 'timezone',
                        type: 'select',
                        label: 'TimeZone',
                        value: '',
                        offsetLeft: '5',
                        required: true,
                        options: [
                            { text: 'Eastern Time (America/New_York)', value: 'America/New_York' },
                            { text: 'Eastern Time - Michigan (America/Detroit)', value: 'America/Detroit' },
                            { text: 'Eastern Time - Indiana (America/Indiana/Indianapolis)', value: 'America/Indiana/Indianapolis' },
                            { text: 'Central Time (America/Chicago)', value: 'America/Chicago' },
                        ],
                    },
                ],
            },
        ];

        this.infoLayout = this.sideBar.cells('login_info').attachLayout('2E');
        this.loginForm = this.infoLayout.cells('a').attachForm(loginFormData);
        this.infoLayout.cells('a').hideHeader();
        this.infoLayout.cells('b').hideHeader();
        this.infoLayout.cells('b').collapse();
        this.infoLayout.cells('b').setText(' ');

        this.rolesGrid = this.infoLayout.cells('b').attachGrid();
        this.rolesGrid.setHeader('Assigned,Role Name', ',', ['text-align:center', 'text-align:center']);
        this.rolesGrid.setImagesPath('css/imgs/');
        this.rolesGrid.setInitWidths('100,*');
        this.rolesGrid.setColAlign('left,left');
        this.rolesGrid.setColTypes('ch,ro');
        this.rolesGrid.setColSorting('int,str');
        this.rolesGrid.init();

        //this.loginForm = this.sideBar.cells('login_info').attachForm(loginFormData);

        const tabFormData = [
            {
                type: 'fieldset',
                name: 'available_tabs',
                label: 'Available Tabs',
                width: 400,
                offsetLeft: '25',
                list: [
                    { type: 'settings', position: 'label-right' },
                    { name: 'avl', type: 'checkbox', label: 'AVL', checked: true },
                    { name: 'fleet', type: 'checkbox', label: 'FLEET', checked: true },
                    { name: 'pm', type: 'checkbox', label: 'PM', checked: true },
                    { type: 'newcolumn', offset: 20 },
                    { name: 'spot_rocking', type: 'checkbox', label: 'SPOT ROCKING', checked: true },
                    { name: 'rock_pits', type: 'checkbox', label: 'ROCK PITS', checked: true },
                    { name: 'rocking', type: 'checkbox', label: 'ROCKING', checked: true },
                    { type: 'newcolumn', offset: 20 },
                    { name: 'grading', type: 'checkbox', label: 'GRADING', checked: true },
                    { name: 'mowing', type: 'checkbox', label: 'MOWING', checked: true },
                    { type: 'newcolumn', offset: 20 },
                    { name: 'plowing', type: 'checkbox', label: 'PLOWING', checked: true },
                    { name: 'spreading', type: 'checkbox', label: 'SPREADING', checked: true },
                    { name: 'camera', type: 'checkbox', label: 'CAMERA', checked: true },
                ],
            },
        ];
        this.tabForm = this.sideBar.cells('tabs').attachForm(tabFormData);

        const settingsFormData = [
            {
                type: 'fieldset',
                name: 'settings',
                label: 'Settings',
                width: 400,
                offsetLeft: '25',
                list: [
                    { type: 'settings', position: 'label-right' },
                    { name: 'zoom_label', type: 'label', label: 'Default Asset Zoom (larger = closer)' },

                    { name: 'zoom_slider', type: 'container', label: '15' },

                    { name: 'asset_tail', type: 'checkbox', label: 'Show Asset Tail', checked: true },
                    { name: 'use_icons', type: 'checkbox', label: 'Use Icons', checked: false },
                    { name: 'use_cluster', type: 'checkbox', label: 'Cluster Markers', checked: false },
                ],
            },
        ];
        this.settingsForm = this.sideBar.cells('settings').attachForm(settingsFormData);
        this.zoomSlider = new dhtmlXSlider(
            this.settingsForm.getContainer('zoom_slider') as HTMLElement, // parent
            250, // size
            '', // skin (or null)
            0, // vertical (0 = horizontal)
            0, // min
            30, // max
            15, // value
            1
        ); // step
        this.zoomSlider.attachEvent('onChange', (value: number) => {
            //this.settingsForm.setItemLabel('zoom_slider', value.toString(), value.toString());
            this.settingsForm.setItemLabel('zoom_slider', value.toString());
        });

        this.populateTable();
        this.sideBar.cells('login_info').setActive();
    }

    /** Setup the UI event handlers
     *
     */
    private buildHandlers() {
        this.toolbar.attachEvent('onClick', (itemId) => {
            this.toolbarEvent(itemId);
        });

        this.users.attachEvent('onRowSelect', (id) => {
            this.userRowSelected(id);
        });
    }

    /** User has selected a row in the user list.
     * Will populate the form with the data for that user.
     * Will not populate password field
     *
     * @param id
     */
    private userRowSelected(id: string | number): void {
        const user = this.cache.get(id as string);
        if (user) {
            this.uncheckAllTabs();
            this.loginForm.setItemValue('id', user.id);
            this.loginForm.setItemValue('username', user.username);
            this.loginForm.checkItem('editor', user.editor ? '1' : '0');
            this.loginForm.setItemValue('timezone', user.timezone);

            const settings = JSON.parse(user.settings) as UserSettings;
            console.log(settings);
            settings.tabs.forEach((tab) => {
                this.tabForm.checkItem(tab);
            });

            if (settings.asset_tail == true) {
                this.settingsForm.checkItem('asset_tail');
            } else {
                this.settingsForm.uncheckItem('asset_tail');
            }
            if (settings.icons == true) {
                this.settingsForm.checkItem('use_icons');
            } else {
                this.settingsForm.uncheckItem('use_icons');
            }
            if (settings.cluster == true) {
                this.settingsForm.checkItem('use_cluster');
            } else {
                this.settingsForm.uncheckItem('use_cluster');
            }

            if (settings.defaulltZoom != undefined) {
                this.zoomSlider.setValue(settings.defaulltZoom, false);
                this.settingsForm.setItemLabel('zoom_slider', settings.defaulltZoom.toString());
            } else {
                this.zoomSlider.setValue(15, false);
                this.settingsForm.setItemLabel('zoom_slider', '15');
            }

            this.rolesGrid.uncheckAll();
            if (user.assignedRoles && user.assignedRoles.length > 0) {
                user.assignedRoles.forEach((roleId) => {
                    this.rolesGrid.cells(roleId, 0).setValue('1');
                });
            }
        }
    }

    /** Make request to server to populate the grid.
     * Also adds the user to data cache.
     *
     */
    private populateTable() {
        this.users.clearAll(false);
        this.cache.clear();

        const userList = this.service.getUsers();

        userList.then((response) => {
            if (response.parsedBody) {
                const users = response.parsedBody;
                users.forEach((user) => {
                    this.users.addRow(user.id, user.username, '', '', '', false);
                    this.cache.set(user.id, user);
                });

                const currentUser = this.service.userSettings.userId;
                this.users.selectRowById(currentUser, false, true, true);

                if (users.length == 1) {
                    this.layout.cells('a').collapse();
                }
            }
        });

        this.rolesGrid.clearAll(false);

        VisionApplication.getInstance()
            .securityService.getAvailableRoles()
            .then((roles) => {
                roles.forEach((role) => {
                    this.rolesGrid.addRow(role.id, ['0', role.name], 0, '', '', false);
                });
            });
    }

    private toolbarEvent(itemId: string): void {
        switch (itemId) {
            case 'new': {
                this.clearForm();
                break;
            }
            case 'save': {
                this.saveForm();
                break;
            }
            case 'delete': {
                this.deleteUser();
                break;
            }
        }
    }

    private deleteUser() {
        const selected = this.users.getSelectedRowId();
        if (selected != undefined) {
            const user = this.cache.get(selected as string);
            dhtmlx.confirm({
                type: 'confirm-warning',
                title: 'Confirm Delete',
                text: 'Delete User: ' + user?.username + '?',
                callback: (result: boolean) => {
                    this.deleteConfirm(result);
                },
            });
        }
    }

    /** The callback for the confirm handler to delete a user.
     *
     *  Will repopulate the tree and notify of success.
     *
     * @param result true if user should be deleted. false if not.
     * @returns None
     */
    private deleteConfirm(result: boolean) {
        if (result == false) {
            return;
        } else {
            const selected = this.users.getSelectedRowId();
            if (selected != undefined) {
                const user = this.cache.get(selected as string);
                if (user) {
                    this.service.deleteUser(user).then(() => {
                        this.populateTable();
                        dhtmlx.message({
                            title: 'Complete',
                            text: 'User was deleted.',
                            type: 'alert-success',
                        });
                        this.clearForm();
                    });
                }
            }
        }
    }

    private saveForm(): void {
        const user = {} as UserDTO;
        const settings = {} as UserSettings;
        settings.tabs = new Array<string>();

        user.id = this.loginForm.getItemValue('id');
        user.username = this.loginForm.getItemValue('username');
        user.password = this.loginForm.getItemValue('password');
        user.timezone = this.loginForm.getItemValue('timezone');
        settings.asset_tail = this.settingsForm.isItemChecked('asset_tail');
        settings.icons = this.settingsForm.isItemChecked('use_icons');
        settings.cluster = this.settingsForm.isItemChecked('use_cluster');
        settings.defaulltZoom = Number(this.zoomSlider.getValue());

        user.assignedRoles = new Array<string>();
        this.rolesGrid.forEachRow((id) => {
            if (this.rolesGrid.cells(id, 0).getValue() != '0') {
                user.assignedRoles.push(id);
            }
        });

        this.tabs.forEach((tab) => {
            if (this.tabForm.isItemChecked(tab)) {
                settings.tabs.push(tab);
            }
        });
        user.settings = JSON.stringify(settings);

        if (user.id == null || user.id == '') {
            this.service.createUser(user).then((data) => {
                if (data.status != 500) {
                    if (data.parsedBody) {
                        const savedUser = data.parsedBody;
                        this.cache.set(savedUser.id, savedUser);
                        this.populateTable();

                        dhtmlx.message({
                            title: 'Save Complete',
                            text: 'User ' + savedUser.username + ' was saved.',
                            type: 'alert-success',
                        });
                    }
                }
            });
        } else {
            this.service.updateUser(user).then((data) => {
                if (data.parsedBody) {
                    const savedUser = data.parsedBody;
                    this.cache.set(savedUser.id, savedUser);
                    this.populateTable();
                    dhtmlx.message({
                        title: 'Save Complete',
                        text: 'User ' + savedUser.username + ' was updated.',
                        type: 'alert-success',
                    });
                    VisionApplication.getInstance().userService.settings.defaulltZoom = settings.defaulltZoom;
                }
            });
        }
    }

    /** Clears out the form of any data that was entered into it.
     * Usually for when the users selects "new"
     *
     */
    private clearForm() {
        this.loginForm.setItemValue('id', null);
        this.loginForm.setItemValue('username', null);
        this.loginForm.setItemValue('password', null);
        this.loginForm.setItemValue('timezone', 'America/Chicago');

        this.tabForm.checkItem('avl');
        this.tabForm.checkItem('fleet');
        this.tabForm.checkItem('pm');
        this.tabForm.checkItem('spot_rocking');
        this.tabForm.checkItem('rock_pits');
        this.tabForm.checkItem('rocking');
        this.tabForm.checkItem('grading');
        this.tabForm.checkItem('mowing');
        this.tabForm.checkItem('plowing');
        this.tabForm.checkItem('spreading');
        this.tabForm.checkItem('camera');
        this.tabForm.checkItem('asset_tail');
        this.tabForm.uncheckItem('use_icons');

        this.settingsForm.uncheckItem('asset_tail');
        this.settingsForm.uncheckItem('use_icons');
        this.settingsForm.uncheckItem('use_cluster');
    }

    private uncheckAllTabs() {
        this.tabForm.uncheckItem('asset_tail');
        this.tabForm.uncheckItem('avl');
        this.tabForm.uncheckItem('fleet');
        this.tabForm.uncheckItem('pm');
        this.tabForm.uncheckItem('spot_rocking');
        this.tabForm.uncheckItem('rock_pits');
        this.tabForm.uncheckItem('rocking');
        this.tabForm.uncheckItem('grading');
        this.tabForm.uncheckItem('mowing');
        this.tabForm.uncheckItem('plowing');
        this.tabForm.uncheckItem('spreading');
        this.tabForm.uncheckItem('camera');
    }
}
